<template>
  <div>
    <div>
      <breadcrumb :breadcrumb_link="Omorovicza_breadcrumb" />
    </div>

    <div class="outterBox">
      <div class="header">
        <!--      <h1 class="overlay">SPECIAL SOUVENIR</h1>-->
        <!--      <img src="@/assets/images/Podohotel/about_headerimage.jpg" />-->
        <div class="headerimage" />
      </div>

      <div class="container contentDesc">
        <div class="title1">
          <div class="col-lg-12 text-center">
            <div style="color: #b9b1b1; margin-bottom: 10px">{{ $t('benefit_program_subtitle') }}</div>
          </div>
          <h2>
            <strong>{{ $t('benefit_program_title') }}</strong>
          </h2>
        </div>
      </div>

      <div class="container">
        <div class="row d-flex justify-content-center">
          <!--          <div>-->
          <!--            &lt;!&ndash;          <div class="overlay"><h1>SPECIAL BENEFITS</h1></div>&ndash;&gt;-->
          <!--            <img src="@/assets/images/Podohotel/benefitinfo_headerimage.png" />-->
          <!--          </div>-->
          <!--          <div class="wedding_body_hedaer text-center col-lg-12 mt-5 mb-4">-->
          <!--            <h2><strong>V SPA</strong></h2>-->
          <!--          </div>-->

          <img class="imageStyle" src="@/assets/images/Podohotel/benefitinfo_bodyimage01.jpg" />
        </div>

        <div class="row d-inline-block pt-5 pb-5 p-2">
          <div class="mb-5">
            <div class="mx-5">
              {{ $t('benefit_program_desc') }}
            </div>
          </div>
          <hr />
          <table class="table table-borderless mt-5 mx-auto col-lg-8 col-12">
            <tbody>
              <tr class="d-flex flex-column mb-4">
                <td class="font-weight-bold">{{ $t('benefit_program_table_td1') }}</td>
                <td>{{ $t('benefit_program_table_td2') }}</td>
              </tr>
              <tr class="d-flex flex-column mb-4">
                <td class="font-weight-bold">{{ $t('benefit_program_table_td3') }}</td>
                <td>{{ $t('benefit_program_table_td4') }}</td>
              </tr>
              <tr class="d-flex flex-column mb-4">
                <td class="font-weight-bold">{{ $t('benefit_program_table_td5') }}</td>
                <td>{{ $t('benefit_program_table_td6') }}</td>
              </tr>
              <tr class="d-flex flex-column mb-4">
                <td class="font-weight-bold">{{ $t('benefit_program_table_td7') }}</td>
                <td>{{ $t('benefit_program_table_td8') }}</td>
              </tr>
              <tr class="d-flex flex-column mb-4">
                <td class="font-weight-bold">{{ $t('benefit_program_table_td9') }}</td>
                <td>
                  <a class="text-dark" style="word-break: break-all" target="_blank" href="https://omorovicza.co.kr/">
                    https://omorovicza.co.kr/</a
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb';

export default {
  name: 'Vspa',
  data() {
    return {
      Omorovicza_breadcrumb: {
        toplink: 'HOME',
        prevlink: 'SPECIAL OFFERS',
        present: this.$t('breadcrumb'),
      },
      isLang: 0,
    };
  },
  methods: {
    refreshLocale(newVal) {
      if (newVal === 'ko') {
        this.isLang = 0;
      } else if (newVal === 'en') {
        this.isLang = 1;
      } else if (newVal === 'ja') {
        this.isLang = 2;
      } else {
        this.isLang = 0;
      }

      if (this.isLang === 0) {
        this.Omorovicza_breadcrumb.prevlink = 'SPECIAL OFFERS > 제휴사 혜택 안내';
      } else {
        this.Omorovicza_breadcrumb.prevlink = 'SPECIAL OFFERS > PARTNERSHIP';
      }

      this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
    },
  },
  watch: {
    '$i18n.locale'(newVal, oldVal) {
      this.refreshLocale(newVal);
    },
  },
  async created() {
    this.refreshLocale(this.$i18n.locale);
  },
  mounted() {
    this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
  },
  components: {Breadcrumb},
};
</script>

<style scoped lang="scss">
.table h5 {
  margin: 0;
}
.table td {
  padding: 5px;
}

h5 {
  word-break: keep-all;
}

.main-ex-desc {
  vertical-align: bottom;
}

.header {
  position: relative;
  width: 100%;
  padding-top: 0rem;
  > img {
    width: 100%;
  }

  .overlay {
    padding-top: 0rem;
    color: White;
    position: absolute;
    text-align: center;
    z-index: 12;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: lighter;
    letter-spacing: -0.1rem;
  }

  .headerimage {
    display: block;
    width: 100%;
    margin: 0;
    content: url('~@/assets/images/Podohotel/benefitinfo_headerimage.png');
  }
}

.contentDesc {
  padding-top: 3rem;
  padding-bottom: 3rem;
  text-align: center;
}

.outterBox {
}

@media (max-width: 992px) {
  .header {
    display: none;
  }
  .outterBox {
    padding-top: 5rem;
  }

  h2 {
    font-size: 1.5rem !important;
  }

  h3 {
    font-size: 1.3rem !important;
  }

  h4 {
    font-size: 1rem !important;
  }

  h5 {
    line-height: 1.6rem !important;
    font-size: 1rem !important;
  }

  .imageStyle {
    width: 100%;
  }
}
</style>

<i18n>
{
  "ko": {
    "breadcrumb": "오모로비짜 스파",
    "benefit_program_subtitle" : "헝가리 부다페스트 프리미엄 스킨케어",
    "benefit_program_title" : "오모로비짜 스파",
    "benefit_program_desc" : "오모로비짜는 2,000년 전에 힐링 효과를 지닌 헝가리 온천수를 발견하면서 시작되었습니다. 순수 미네랄을 함유한 힐링 온천수로 만든 제품을 이용하여 건강하고 맑은 피부 관리, 피로를 풀어주는 테라피 등을 진행합니다. 테라피스트의 케어를 통해 여행 중 편안한 휴식을 경험하세요.",
    "benefit_program_table_td1" : "할인혜택",
    "benefit_program_table_td2" : "핀크스 이용고객 10% 할인",
    "benefit_program_table_td3" : "이용방법",
    "benefit_program_table_td4" : "사전 예약 후, 핀크스 표준명함(프론트 비치) 제시",
    "benefit_program_table_td5" : "주소",
    "benefit_program_table_td6" : "제주 서귀포시 중문관공로72번길 그랜드조선 제주 본관 1층",
    "benefit_program_table_td7" : "문의번호",
    "benefit_program_table_td8" : "070-8900-0033",
    "benefit_program_table_td9" : "웹사이트"
  },
  "en": {
    "breadcrumb": "Omorovicza Spa",
    "benefit_program_subtitle" : "헝가리 부다페스트 프리미엄 스킨케어",
    "benefit_program_title" : "오모로비짜 스파",
    "benefit_program_desc" : "오모로비짜는 2,000년 전에 힐링 효과를 지닌 헝가리 온천수를 발견하면서 시작되었습니다. 순수 미네랄을 함유한 힐링 온천수로 만든 제품을 이용하여 건강하고 맑은 피부 관리, 피로를 풀어주는 테라피 등을 진행합니다. 테라피스트의 케어를 통해 여행 중 편안한 휴식을 경험하세요.",
    "benefit_program_table_td1" : "할인혜택",
    "benefit_program_table_td2" : "핀크스 이용고객 10% 할인",
    "benefit_program_table_td3" : "이용방법",
    "benefit_program_table_td4" : "사전 예약 후, 핀크스 표준명함(프론트 비치) 제시",
    "benefit_program_table_td5" : "주소",
    "benefit_program_table_td6" : "제주 서귀포시 중문관공로72번길 그랜드조선 제주 본관 1층",
    "benefit_program_table_td7" : "문의번호",
    "benefit_program_table_td8" : "070-8900-0033",
    "benefit_program_table_td9" : "웹사이트"
  },
  "ja": {
  }
}
</i18n>
